import { render, staticRenderFns } from "./SToolbarCrud.vue?vue&type=template&id=61e49198&"
import script from "./SToolbarCrud.vue?vue&type=script&lang=js&"
export * from "./SToolbarCrud.vue?vue&type=script&lang=js&"
import style0 from "./SToolbarCrud.vue?vue&type=style&index=0&id=61e49198&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports